import { Component, OnInit } from "@angular/core";
import { ConfigClass, ViewPrivilege } from "../../config";

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  role: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "dashboard",
    class: "",
    role: ViewPrivilege.DASHBOARD,
  },
  // {
  //   path: "/CatgSubscription",
  //   title: "Categorois Subscription",
  //   icon: "group_work",
  //   class: "",
  //   role: ViewPrivilege.SUBSCRIPTION_CATEGORY
  // },
  {
    path: "/gateAccess",
    title: "Gate access",
    icon: "accessibility",
    class: "",
    role: ViewPrivilege.GATE_ACCESS,
  },
  {
    path: "/access-card",
    title: "Access Card",
    icon: "art_track",
    class: "",
    role: ViewPrivilege.ACCESS_CARD,
  },
  {
    path: '/complaints',
    title: "All Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.CS_COMPLAIN,
  }, 
  {
    path: '/complaints-agriculture',
    title: "Agriculture Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_AGRICULTURE,
  },
  {
    path: '/complaints-engineering',
    title: "Engineering Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_ENGINEERING,
  },
  {
    path: '/complaints-environment',
    title: "Environment Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_ENVIRONMENT,
  },
  {
    path: '/complaints-financial',
    title: "Financial Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_FINANCIAL,
  },
  {
    path: '/complaints-maintenance',
    title: "Maintenance Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_MAINTENANCE,
  },
  {
    path: '/complaints-security',
    title: "Security Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_SECURITY,
  },
  {
    path: '/complaints-transportation',
    title: "Transportation Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_TRANSPORTATION,
  },
  {
    path: '/complaints-others',
    title: "Others Complaints",
    icon: "face",
    class: "",
    role: ViewPrivilege.COMPLAIN_OTHER,
  },
  {
    path: "/projects",
    title: "Projects",
    icon: "account_balance",
    class: "",
    role: ViewPrivilege.PROJECTS,
  },
  {
    path: "/properity",
    title: "Property",
    icon: "person",
    class: "",
    role: ViewPrivilege.PROPERTY,
  },
  {
    path: "/sos",
    title: "SOS",
    icon: "sos",
    class: "",
    role: ViewPrivilege.SOS,
  },
  {
    path: "/orders",
    title: "Operations Orders",
    icon: "content_paste",
    class: "",
    role: ViewPrivilege.ORDERS,
  },
  {
    path: "/cuOrders",
    title: "Agent Orders",
    icon: "content_paste",
    class: "",
    role: ViewPrivilege.CS_ORDERS,
  },
  {
    path: "/customized-orders",
    title: "Operations Cust Orders",
    icon: "work",
    class: "",
    role: ViewPrivilege.CUSTOMIZED_ORDERS,
  },
  {
    path: "/CuCustomized-orders",
    title: "Agent Cust Orders",
    icon: "work",
    class: "",
    role: ViewPrivilege.CS_CUSTOMIZED_ORDERS,
  },
  {
    path: "/users",
    title: "Users",
    icon: "person_add",
    class: "",
    role: ViewPrivilege.USERS,
  },
  {
    path: "/subscription",
    title: "Subscription",
    icon: "monetization_on",
    class: "",
    role: ViewPrivilege.SUBSCRIPTION,
  },
  {
    path: "/subscription-Catg",
    title: "Subscription Category",
    icon: "category",
    class: "",
    role: ViewPrivilege.SUBSCRIPTION_CATEGORY,
  },
  {
    path: "/customized-service",
    title: "service",
    icon: "room_service",
    class: "",
    role: ViewPrivilege.SERVICE,
  },
  {
    path: "/offers",
    title: "Offers",
    icon: "local_offer",
    class: "",
    role: ViewPrivilege.OFFERS,
  },
  {
    path: "/ChangePassword",
    title: "Change Password",
    icon: "cached",
    class: "",
    role: "",
  },
  {
    path: "/timeline",
    title: "Timeline",
    icon: "notification_important",
    class: "",
    role: ViewPrivilege.NOTIFICATIONS,
  },
  {
    path: "/send-Notification",
    title: "Send notification",
    icon: "notification_important",
    class: "",
    role: ViewPrivilege.NOTIFICATIONS,
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  menuItems: any[] = [];

  constructor() {}
  BreakException = {};
  ngOnInit() {
    let privilage = JSON.parse(sessionStorage.getItem("privilage"));
    let privilagesStatus = sessionStorage.getItem("setPrivilageStatus");
    ConfigClass.setPrivilageStatus = privilagesStatus == "true" ? true : false;
    if (ConfigClass.getPrivilageStatus) {
      ROUTES.forEach((menuItem) => {
        try {
          privilage.forEach((element) => {
            let role = element.name
              .replace("_EDIT", "")
              .replace("_VIEW", "")
              .replace("_SEND", "");
            if (menuItem.role == role) {
              this.menuItems.push(menuItem);
              throw this.BreakException;
            }
          });
        } catch (e) {}
        if (menuItem.role == "") {
          this.menuItems.push(menuItem);
        }
      });
    } else {
      this.menuItems = ROUTES;
    }
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }
}
